// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow+Semi+Condensed:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.texts-container {
	font-family: "Barlow Semi Condensed", sans-serif;
	color: #fff;
	width: 100%;
	text-align: center;
	position: absolute;
	top: 0%;
	left: 0%;
	font-size: 3rem;
	font-weight: 600;
	height: 100%;
	display: flex;
	justify-content: center;
	align-content: center;
	flex-wrap: wrap;
}

.texts-container>div {
	display: inline-block;
	animation-name: title;
	animation-duration: 10s;
	animation-iteration-count: infinite;
	line-height: 3rem;
}

.texts-container .italics {
	font-style: italic;
	font-weight: 300;
}

@keyframes title {
	0% {
		opacity: 0;
	}

	10% {
		opacity: 0;
	}
	20% {
		opacity: 0;
	}


	30% {
		opacity: 1;
	}
	40% {
		opacity: 1;
	}

	50%{
		opacity: 1;
	}
	60% {
		opacity: 1;
	}

	70% {
		opacity: 1;
	}
	90% {
		opacity: 0;
	}
	100% {
		opacity: 0;
	}
}

.birds-root {
	width: 100vw;
	height: calc(100vw * 9 / 16);
}

@media only screen and (max-width: 600px) {
	.texts-container {
		font-size: 1rem;
	}
	.texts-container>div {
		line-height: 1rem;
	}
  }`, "",{"version":3,"sources":["webpack://./src/styles/style.css"],"names":[],"mappings":"AAEA;CACC,gDAAgD;CAChD,WAAW;CACX,WAAW;CACX,kBAAkB;CAClB,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,eAAe;CACf,gBAAgB;CAChB,YAAY;CACZ,aAAa;CACb,uBAAuB;CACvB,qBAAqB;CACrB,eAAe;AAChB;;AAEA;CACC,qBAAqB;CACrB,qBAAqB;CACrB,uBAAuB;CACvB,mCAAmC;CACnC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC;EACC,UAAU;CACX;;CAEA;EACC,UAAU;CACX;CACA;EACC,UAAU;CACX;;;CAGA;EACC,UAAU;CACX;CACA;EACC,UAAU;CACX;;CAEA;EACC,UAAU;CACX;CACA;EACC,UAAU;CACX;;CAEA;EACC,UAAU;CACX;CACA;EACC,UAAU;CACX;CACA;EACC,UAAU;CACX;AACD;;AAEA;CACC,YAAY;CACZ,4BAA4B;AAC7B;;AAEA;CACC;EACC,eAAe;CAChB;CACA;EACC,iBAAiB;CAClB;EACC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Barlow+Semi+Condensed:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\r\n\r\n.texts-container {\r\n\tfont-family: \"Barlow Semi Condensed\", sans-serif;\r\n\tcolor: #fff;\r\n\twidth: 100%;\r\n\ttext-align: center;\r\n\tposition: absolute;\r\n\ttop: 0%;\r\n\tleft: 0%;\r\n\tfont-size: 3rem;\r\n\tfont-weight: 600;\r\n\theight: 100%;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-content: center;\r\n\tflex-wrap: wrap;\r\n}\r\n\r\n.texts-container>div {\r\n\tdisplay: inline-block;\r\n\tanimation-name: title;\r\n\tanimation-duration: 10s;\r\n\tanimation-iteration-count: infinite;\r\n\tline-height: 3rem;\r\n}\r\n\r\n.texts-container .italics {\r\n\tfont-style: italic;\r\n\tfont-weight: 300;\r\n}\r\n\r\n@keyframes title {\r\n\t0% {\r\n\t\topacity: 0;\r\n\t}\r\n\r\n\t10% {\r\n\t\topacity: 0;\r\n\t}\r\n\t20% {\r\n\t\topacity: 0;\r\n\t}\r\n\r\n\r\n\t30% {\r\n\t\topacity: 1;\r\n\t}\r\n\t40% {\r\n\t\topacity: 1;\r\n\t}\r\n\r\n\t50%{\r\n\t\topacity: 1;\r\n\t}\r\n\t60% {\r\n\t\topacity: 1;\r\n\t}\r\n\r\n\t70% {\r\n\t\topacity: 1;\r\n\t}\r\n\t90% {\r\n\t\topacity: 0;\r\n\t}\r\n\t100% {\r\n\t\topacity: 0;\r\n\t}\r\n}\r\n\r\n.birds-root {\r\n\twidth: 100vw;\r\n\theight: calc(100vw * 9 / 16);\r\n}\r\n\r\n@media only screen and (max-width: 600px) {\r\n\t.texts-container {\r\n\t\tfont-size: 1rem;\r\n\t}\r\n\t.texts-container>div {\r\n\t\tline-height: 1rem;\r\n\t}\r\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
